<template>
    <div>
        <pc-label
            v-if="label"
            v-bind="labelBinder"
            v-on:help-clicked="$emit('help-clicked')" />
        <textarea
            v-bind="binder"
            ref="input"
            v-model="internalValue"
            v-bind:rows="rowsInternal"
            v-bind:maxlength="maxlength"
            class="form-control d-block d-print-none"
            no-interact
            v-on="listeners" />
        <div class="d-none d-print-block form-control textarea-printable">
            {{ internalValue }}
        </div>
        <div
            v-if="showRemainingCharacters && !inPrintStyle"
            class="d-flex align-items-center justify-content-end mb-3">
            <div class="text-body-secondary fst-italic small">
                {{ remainingCharacters }}
            </div>
        </div>
        <div
            v-if="showValidationErrors"
            class="invalid-feedback fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";
    import { KEYS, NAMESPACE } from "./i18n/pcInput.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        extends: base,
        props: {
            rows: { type: Number, required: false, default: 6 },
            maxAutoExpandRows: { type: Number, required: false, default: null },
            maxlength: { type: Number, required: false, default: null },
            showRemainingCharacters: { type: Boolean, required: false, default: false }
        },
        emits: ["help-clicked"],
        data() {
            return {
                rowsInternal: this.rows
            };
        },
        computed: {
            remainingCharacterCount() {
                if (this.showRemainingCharacters && !this.maxlength) {
                    throw "maxlength must be set to show remaining characters";
                }
                return this.maxlength - this.internalValue.length;
            },
            inPrintStyle() {
                return this.$app.PrintStyling;
            },
            ...mapI18n(
                {
                    ...KEYS,
                    remainingCharacters() {
                        return {
                            key: KEYS.remainingCharsLabel,
                            values: {
                                remainingChars: this.remainingCharacterCount
                            }
                        };
                    }
                },
                NAMESPACE
            )
        },
        mounted() {
            // If the textarea is set to auto-expand, expand it when the page loads if necessary
            if (this.maxAutoExpandRows) {
                const lineHeight = parseFloat(window.getComputedStyle(this.$refs.input).lineHeight);
                const scrollHeight = this.$refs.input.scrollHeight;
                const numRows = Math.floor(scrollHeight / lineHeight);
                if (numRows > this.rows) {
                    this.rowsInternal = Math.min(numRows, this.maxAutoExpandRows);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .textarea-printable {
        height: auto !important;
        min-height: calc(6 * var(--pc-input-height)) !important;
    }
</style>
